export default "__VITE_ASSET__BNNhBHb6__"